/*
 * @Author: zhaihaooran
 * @Date: 2021-07-13 21:41:50
 * @LastEditors: OBKoro1
 * @FilePath: /umu_mobile/src/businessCommon/hooks/useToggle.ts
 */
import { useState, useMemo } from 'react';

type IState = string | number | boolean | undefined;

export interface IActions<T = IState> {
    setLeft: () => void;
    setRight: () => void;
    toggle: (value?: T) => void;
}

function useToggle<T = boolean | undefined>(): [boolean, IActions<T>];

function useToggle<T = IState>(defaultValue: T): [T, IActions<T>];

function useToggle<T = IState, U = IState>(defaultValue: T, reverseValue: U): [T | U, IActions<T | U>];

function useToggle<D extends IState = IState, R extends IState = IState>(
    defaultValue: D = false as D,
    reverseValue?: R
) {
    const [state, setState] = useState<D | R>(defaultValue);

    const actions = useMemo(() => {
        const reverseValueOrigin = (reverseValue === undefined ? !defaultValue : reverseValue) as D | R;

        // 切换返回值
        const toggle = (value?: D | R) => {
            // 强制返回状态值，适用于点击操作
            if (value !== undefined) {
                setState(value);
                return;
            }
            setState((s) => (s === defaultValue ? reverseValueOrigin : defaultValue));
        };
        // 设置默认值
        const setLeft = () => setState(defaultValue);
        // 设置取反值
        const setRight = () => setState(reverseValueOrigin);
        return {
            toggle,
            setLeft,
            setRight
        };
    }, [defaultValue, reverseValue]);

    return [state, actions];
}

export { useToggle };
